export const modal = {
    heading: "Thanks for Visiting True Stories!",
    body: "Please remember that True Stories content has been generated by customers in their own words, and may not represent the thoughts or opinions of The Honest Kitchen or its staff. The Honest Kitchen's products are not intended to diagnose, treat or cure any disease. Please consult your veterinarian if your pet has health concerns.",
    buttonLabel: "Continue"
};
